import { createSelector } from 'reselect';

const key = 'talkToUs';

const domains = {
    TalkToUsIsOpen: (state) => state.global[key].TalkToUsIsOpen,
};

const selectorTalkToUsIsOpen = createSelector(
    [domains.TalkToUsIsOpen],
    (TalkToUsIsOpen) => TalkToUsIsOpen
);

const makeSelectTalkToUsIsOpen = () => selectorTalkToUsIsOpen;

export { makeSelectTalkToUsIsOpen };
